export default {
  loading: true,
  loadingBrands: true,
  laodingLocations: true,
  user: null,
  brands: [],
  locations: [],
}